/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ user: NonNullable<unknown> }} Project_Locked_ByInputs */



/**
* | output |
* | --- |
* | "This project is currently locked by {user}. You can save as a new copy instead." |
*
* @param {Project_Locked_ByInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_locked_by = /** @type {((inputs: Project_Locked_ByInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Locked_ByInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Ce projet est actuellement verrouillé par ${i?.user}. Vous pouvez enregistrer en tant que nouvelle copie.`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Dieses Projekt ist derzeit von ${i?.user} gesperrt. Sie können es stattdessen als neue Kopie speichern.`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Questo progetto è attualmente bloccato da ${i?.user}. Puoi salvarlo come nuova copia.`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`В настоящее время этот проект заблокирован пользователем ${i?.user}. Вместо этого вы можете сохранить его как новую копию.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Este proyecto está bloqueado por ${i?.user}. Puedes guardarlo como una nueva copia.`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`此项目目前已被${i?.user}锁定。您可以另存为新副本。`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`このプロジェクトは現在${i?.user}によってロックされています。代わりに新しいコピーとして保存できます。`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`यह प्रोजेक्ट वर्तमान में ${i?.user} द्वारा लॉक किया गया है। आप इसके बजाय एक नई कॉपी सहेज सकते हैं।`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Este projeto está atualmente bloqueado por ${i?.user}. Você pode salvá-lo como uma nova cópia.`)
	return /** @type {LocalizedString} */ (`This project is currently locked by ${i?.user}. You can save as a new copy instead.`)
});